import { InteractPlan } from "../components/InteractPlan";
import { StadiumPlan } from "../components/StadiumPlan";
import { SplitView } from "../Views/SplitView";
import { EventEmitter } from "../utils/EventEmitter";
import { helpers } from "../utils/Helpers";
import { utils } from "../utils";
import { SplitModel } from "../Models/SplitModel";
import { EventModel } from "../Models/EventModel";
import { BottomOrderInfo } from "../components/BottomOrderInfo";
import lkService from "../services/lkService";
import { helpers as shopHelpers } from "@shop/frontend/web/js/helpers";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";

const emitter = new EventEmitter();

export default class SplitController {
	constructor(view, model) {
		this.view = view;
		this.model = model;
		this.eventModel = new EventModel();
		this.orderInfo = new BottomOrderInfo();

		this.firstStadium = null;
		this.secondStadium = null;

		this.firstStadiumPlan = null;
		this.secondStadiumPlan = null;
		this.fanSectorInfoShown = false;
	}

	/**
	 * Инициализация абонемента на два плана
	 */
	initSplitStep() {
		/** инициализируем стадионы */
		this.firstStadium = new StadiumPlan({
			$stadiumPlan: this.view.$firstStadium,
			$sectorPlan: this.view.$firstSector,
		});
		this.secondStadium = new StadiumPlan({
			$stadiumPlan: this.view.$secondStadium,
			$sectorPlan: this.view.$secondSector,
		});

		if (window.INITIAL_EVENT_ORDER)
			this.orderInfo.updateOrder(window.INITIAL_EVENT_ORDER, this.model.getEventId());

		if (window.SHOW_CHILD_TICKET_INFO) {
			this.showChildTicketInfo();
		} else {
			this.showRulesPopup();
		}

		/**
		 * Добавляем интерактив стадиону
		 */
		const params = {
			addViewBox: true,
			addSectorInfoBLock: true,
			addSectorTapping: true,
		};

		this.firstStadiumPlan = new InteractPlan(
			$.extend(params, {
				svg: this.view.$firstStadiumPlan,
				zoomIn: this.view.$firstStadium.find(".js-svg-zoom-in"),
				zoomOut: this.view.$firstStadium.find(".js-svg-zoom-out"),
			})
		);
		this.secondStadiumPlan = new InteractPlan(
			$.extend(params, {
				svg: this.view.$secondStadiumPlan,
				zoomIn: this.view.$secondStadium.find(".js-svg-zoom-in"),
				zoomOut: this.view.$secondStadium.find(".js-svg-zoom-out"),
			})
		);

		if (this.model.activeTickets.length > 0) this.initActiveViews();

		/** Добавляем обработчики */
		this.splitListeners();
		this.splitSubscribers();

		this.checkIsDisableSecondTab();
	}

	checkIsDisableSecondTab() {
		let ids = new Set(this.model.activeTickets.filter(Boolean).map(i => i.event_id));
		if (ids.has(this.model.firstEventId)) {
			this.view.$secondStadiumTab.removeClass('disable');
		} else {
			this.view.$secondStadiumTab.addClass('disable');
		}
	}

	initActiveViews() {
		this.model.activeEventId = this.model.secondEventId;

		const all = this.model.activeTickets || [];
		this.updateOrderButton(all);

		this.model.splitGetViews().then(res => {
			if (!res) return false;

			this.model.activeViews = res;
		});
	}

	splitListeners() {
		/** Добавляем обработчики */
		this.firstStadiumPlan.on("tap", target => {
			if (target.closest("g[view_id]").length) {
				if (!helpers.isDesktop.matches) if (!helpers.isDesktop.matches) return false;

				return emitter.emit("event:open-sector", {
					$elem: target.closest("g[view_id]"),
					viewId: target.closest("g[view_id]").attr("view_id"),
					stadium: this.firstStadium,
					eventId: this.model.firstEventId,
					$sectorSvg: this.view.$firstSector,
				});
			}
		});

		this.secondStadiumPlan.on("tap", target => {
			if (target.closest("g[view_id]").length) {
				if (!helpers.isDesktop.matches) return false;

				return emitter.emit("event:open-sector", {
					$elem: target.closest("g[view_id]"),
					viewId: target.closest("g[view_id]").attr("view_id"),
					stadium: this.secondStadium,
					eventId: this.model.secondEventId,
					$sectorSvg: this.view.$secondSector,
				});
			}
		});

		/* Обработчики для активного сектора */
		this.view.$firstSector.find(this.view.$backToStadiumBtn).on("click", e => {
			emitter.emit("event:close-sector", {
				stadium: this.firstStadium,
			});
		});
		this.view.$secondSector.find(this.view.$backToStadiumBtn).on("click", e => {
			emitter.emit("event:close-sector", {
				stadium: this.secondStadium,
			});
		});

		/* обработчик для управления табом */
		this.view.$stadiumTab.on("click", e => {
			const eventId = parseInt($(e.currentTarget).attr("data-event-id"));
			if (!eventId) return false;
			if (eventId === this.model.secondEventId) {
				this.orderInfo.renderContinueButton("disable");
			} else {
				this.orderInfo.renderContinueButton("enable");
			}

			return (this.model.activeEventId = eventId);
		});

		/* Обработчики для управления заказом */
		this.view.$cancelOrderBtn.on("click", () => {
			emitter.emit("event:cancel-order", {});
			this.checkIsDisableSecondTab();
		});

		/** Обработчик для перехода к сектору на мобилке */
		this.view.$bottomButton.on("click", e => {
			if (this.view.$bottomButton.attr("data-sector-id")) {
				/** Вызываем событие открыть сектор */
				emitter.emit("event:open-sector", {
					$elem: $(`g[view_id=${this.view.$bottomButton.attr("data-sector-id")}]`)[0],
					viewId: this.view.$bottomButton.attr("data-sector-id"),
					stadium:
						this.model.activeTickets.length > 0
							? this.secondStadium
							: this.firstStadium,
					eventId: this.model.activeEventId,
					$sectorSvg:
						this.model.activeTickets.length > 0
							? this.view.$secondSector
							: this.view.$firstSector,
				});
			}
		});

		/** Обработчик для перехода к след арене */
		this.view.$continueButton.on("click", e => {
			this.model.activeEventId = this.model.secondEventId;
			
			emitter.emit("event:switch-plan", {});

			this.orderInfo.renderContinueButton("disable");
			this.orderInfo.showBuyButton();
		});

		/** Обработчик для кнопки "Оформить заказ" */
		this.orderInfo.$orderButton.on("click", e => {
			e.preventDefault();

			if ($(e.currentTarget).hasClass("disabled")) return false;
			const targetUrl = $(e.currentTarget).attr("href");

			this.model
				.splitCheckIsEqual()
				.then(res => {
					if (targetUrl) window.location.href = targetUrl;
				})
				.catch(err => {

					if (this._isSplitSeatsMismatchPayload(err)) {
						this._showSplitSeatsMismatchModal(err);
						return;
					}

				});
		});
	}

	_isSplitSeatsMismatchPayload(payload) {
		if (!payload || typeof payload !== "object" || Array.isArray(payload)) return false;

		const values = Object.values(payload);
		if (!values.length) return false;

		return values.every(item => {
			return (
				item &&
				typeof item === "object" &&
				typeof item.unitName === "string" &&
				typeof item.count !== "undefined"
			);
		});
	}

	_showSplitSeatsMismatchModal(payload) {
		const $root = $('<div class="split-seats-mismatch"></div>');
		const $title = $('<div class="modal__title split-seats-mismatch__title"></div>').text(
			translator.t("main", "Вы выбрали разное количество мест")
		);
		const $rowsWrap = $('<div class="split-seats-mismatch__rows"></div>');
		const $hint = $('<div class="modal__text split-seats-mismatch__hint"></div>').text(
			translator.t("main", "Чтобы продолжить, выберите одинаковое количество мест на всех матчах")
		);

		Object.values(payload).forEach(item => {
			const count = Number(item.count) || 0;
			const $row = $("<div></div>");
			const $label = $("<span></span>").text(`${item.unitName} - `);
			const placeWord = shopHelpers.wordEnding(count, [
				translator.t("event", "seat"),
				translator.t("event", "seats"),
				translator.t("event", "seats "),
			]);
			const $count = $('<b class="split-seats-mismatch__count"></b>').text(`${count} ${placeWord}`);
			$row.append($label, $count);
			$rowsWrap.append($row);
		});

		$root.append($title, $rowsWrap, $hint);
		const $modal = $("#js-popup-modal");
		const $modalBody = $modal.find(".modal-body");
		$modal.addClass("split-mismatch-modal");
		$modalBody.addClass("split-mismatch-modal__body").empty().append($root);

		$modal.off("hidden.bs.modal.splitMismatchCleanup");
		$modal.on("hidden.bs.modal.splitMismatchCleanup", () => {
			$modal.removeClass("split-mismatch-modal");
			$modalBody.removeClass("split-mismatch-modal__body");
		});

		$modal.off("click.splitMismatchDismiss");
		$modal.on("click.splitMismatchDismiss", ".modal__close, [data-dismiss='modal']", () => {
			$modal.modal("hide");
		});
		$modal.modal("show");
	}

	_getSeatSectorName($place) {
		const value = String($place?.attr("data-name") || "").trim();
		return value.split(/\s+/)[0] || "";
	}

	_isFanSectorName(name = "") {
		return /f$/i.test(String(name).trim());
	}

	_showFanSectorMobileSheet(sectorName, onConfirm) {
		const fanSectorSuffix = translator.t("main", "fan sector");
		const title = sectorName
			? `${sectorName} ${fanSectorSuffix}`
			: translator.t("main", "fan sector");
		const $root = $('<div class="fan-sector-mobile-sheet"></div>');
		const $title = $('<div class="fan-sector-mobile-sheet__title"></div>').text(title);
		const $body = $('<div class="fan-sector-mobile-sheet__body"></div>');
		const $lead = $('<div class="fan-sector-mobile-sheet__lead"></div>').text(
			translator.t("main", "Rules of the active support sector:")
		);
		const $list = $('<ul class="fan-sector-mobile-sheet__list"></ul>');

		const rows = [
			{
				text: translator.t("main", "In this sector, fans often support the team standing."),
			},
			{
				text: translator.t("main", "Seats inside the sector are conventional."),
			},
			{
				text: translator.t(
					"main",
					"Fans of other teams and their attributes are not allowed in this sector. Especially the opponent. Such fans will be removed from the sector."
				),
			},
			{
				text: translator.t("main", "Drums, flags and banners are allowed in this sector."),
			},
			{
				text: translator.t(
					"main",
					"Foul language, intoxication, and displaying indecent behavior or disrespect towards the opponent or referees are prohibited."
				),
			},
		];

		rows.forEach(item => {
			const $li = $('<li class="fan-sector-mobile-sheet__item"></li>');
			if (item.title) {
				$li.append($('<b class="fan-sector-mobile-sheet__item-title"></b>').text(item.title));
			}
			if (item.text) {
				$li.append($('<span class="fan-sector-mobile-sheet__text"></span>').text(item.text));
			}
			$list.append($li);
		});

		const $btn = $('<button type="button" class="btn fan-sector-mobile-sheet__btn" id="js-fan-sector-confirm-add"></button>').text(
			translator.t("main", "ADD")
		);
		$body.append($lead, $list, $btn);
		$root.append($title, $body);

		const $modal = $("#js-popup-modal");
		$modal.addClass("split-fan-sector-modal");
		$modal.find(".modal-body").empty().append($root);

		$modal.off("click.splitFanSectorConfirm");
		$modal.on("click.splitFanSectorConfirm", "#js-fan-sector-confirm-add", e => {
			e.preventDefault();
			$modal.modal("hide");
			onConfirm();
		});

		$modal.off("hidden.bs.modal.splitFanSectorCleanup");
		$modal.on("hidden.bs.modal.splitFanSectorCleanup", () => {
			$modal.removeClass("split-fan-sector-modal");
			$modal.off("click.splitFanSectorConfirm");
		});

		$modal.modal("show");
	}

	_addSplitPlace(data) {
		const sid = data.place.attr("id");

		return this.model
			.splitAdd(this.model.activeEventId, sid, data.viewId)
			.then(res => {
				if (res.need_auth) return window.location.replace(lkService.getLoginUrl());

				if (res.limit)
					return alert(
						"Вы превысили максимально допустимое количество мест для брони. Если вы хотите купить больше билетов, обратитесь на почту ticket@cskabasket.ru или купите билеты с 2-х аккаунтов."
					);

				if (res.redraw) {
					alert("Данное место больше недоступно. Выберите другое. ");
					data.stadium.renderSectorPlan({ place: data.place }, "redraw");
					return false;
				}

				if (!res.result) throw res;
				if (!res.items) return false;

				this.model.activeTickets = this.model.filterActiveTicketsByEvent(res.items);

				if (this.hasTicketsInEachPlan(res.items)) {
					this.orderInfo.renderContinueButton("disable");
				} else {
					this.orderInfo.renderContinueButton("enable");
				}

				const orderData = {
					carts: this.model.activeTickets,
					order: {
						count_tickets: this.model.activeTickets.length,
						amount: this.model.getTotalSum(),
					},
				};

				this.orderInfo.renderBottomOrderInfo(orderData, "add");
				this.updateOrderButton(res.items || []);
				data.stadium.renderSectorPlan({ place: data.place }, "add");
				this.checkIsDisableSecondTab();
			})
			.catch(err => {
				console.log(err);

				if (err.message == "Не удалось получить url личного кабинета!") {
					return alert("Необходима авторизация!");
				}

				alert(`${err.msg ? err.msg : "Ошибка!"}`);
			});
	}

	clearOrder() {
		this.model.splitRemoveNew(ticket.event_id, ticket.id).then(res => {
			const data = {
				carts: [{ sid: ticket.id }],
			};

			this.firstStadium.renderSectorPlan(data, "remove");
			this.secondStadium.renderSectorPlan(data, "remove");
			this.orderInfo.renderBottomOrderInfo({ count: 0 }, "remove");

			window.dispatchEvent(new CustomEvent("cart:cleared", {
				detail: { eventId: this.model.eventId }
			}));
		});

		this.firstStadium.renderSectorInfo({}, "close");
		this.secondStadium.renderSectorInfo({}, "close");

		this.model.activeEventId = this.model.firstEventId;
		this.model.activeTickets = [];
		this.updateOrderButton([]);

		return emitter.emit("event:switch-plan", {});
	}

	splitSubscribers() {
		/**
		 * Событие для открытия сектора
		 * @param data {object} - {
		 *   $elem,
		 *   viewId,
		 *   stadium,
		 *   eventId,
		 *   $sectorSvg
		 * }
		 */
		emitter.subscribe("event:open-sector", data => {
			if (!(data.viewId && data.eventId)) return false;

			this.eventModel.getSvgPrices(data.eventId, data.viewId, true).then(res => {
				if (res.svg) {
					const uniqueZones = helpers.sortArrayInAsc(
						utils.uniqueArrayByProperty(res.prices, "z")
					);
					const activeTickets = this.model.getEventActiveTickets();

					data.stadium.renderSectorPlan(res, "open");
					data.stadium.renderSectorInfo(
						{
							viewId: data.viewId,
							activeTickets: activeTickets,
							uniqueZones: uniqueZones,
							zones: res.zones,
							pricesLength: res.prices.length,
							sector: $(data.$elem),
						},
						"open"
					);

					/** Инициализируем интерактив на плане и вешаем обработчик */
					const interactSector = new InteractPlan({
						svg: data.$sectorSvg.find(".js-sector-svg svg"),
						isCenteredSectorPlan: true,
					});

					interactSector.on("tap", target => {
						if (target.closest("g.active").length) {
							/** Вызываем событие клик по месту в секторе */
							emitter.emit("event:clicked-to-place", {
								place: $(target).closest("g.active"),
								stadium: data.stadium,
								viewId: data.viewId,
								sectorPlan: interactSector,
							});
						}
					});

					this.view.$backToStadiumBtn.show();
				}
			});
		});

		/* Подписчики для активного сектора */
		emitter.subscribe("event:close-sector", data => {
			data.stadium.renderSectorInfo({}, "close");
		});

		emitter.subscribe("event:clicked-to-place", data => {
			const sid = data.place.attr("id");

			/**
			 * Если место уже активное то удаляем из корзины
			 * @return true - Прекращаем работу подписчика
			 */
			if (data.place.data("available") === "false") {
				const prevItems = (this.model.activeTickets || []).slice();

				this.model.splitRemove(this.model.activeEventId, sid, data.viewId).then(res => {
					if (res.error) return window.location.reload();

					if (!res.result) return false;

					if (res.redraw) alert("Данное место больше недоступно. Выберите другое. ");

					const afterItems = res.items || [];

					this.model.activeTickets = this.model.filterActiveTicketsByEvent(afterItems);


					if (afterItems.length === 0) {
						const payload = { carts: prevItems.map(t => ({ sid: t.id })) };
						this.firstStadium.renderSectorPlan(payload, "remove");
						this.secondStadium.renderSectorPlan(payload, "remove");
					} else {
						const afterIds = new Set(afterItems.map(t => t.id));
						const removedIds = prevItems
							.filter(t => !afterIds.has(t.id))
							.map(t => t.id);

						if (removedIds.length) {
							const payload = { carts: removedIds.map(id => ({ sid: id })) };
							this.firstStadium.renderSectorPlan(payload, "remove");
							this.secondStadium.renderSectorPlan(payload, "remove");
						}
					}

					this.orderInfo.renderBottomOrderInfo(
						{
							count: this.model.activeTickets.length || 0,
							carts: this.model.activeTickets || [],
							summ: this.model.getTotalSum(),
						},
						"remove"
					);

					this.updateOrderButton(res.items || []);
					this.checkIsDisableSecondTab();
				});

				return true;
			}

			/**
			 * Если все ок то добавляем в корзину
			 */
			const seatSectorName = this._getSeatSectorName(data.place);
			const isMobile = !helpers.isDesktop.matches;
			const isFanSector = this._isFanSectorName(seatSectorName);

			if (isMobile && isFanSector && !this.fanSectorInfoShown) {
				this.fanSectorInfoShown = true;
				this._showFanSectorMobileSheet(seatSectorName, () => this._addSplitPlace(data));
				return true;
			}

			this._addSplitPlace(data);
		});

		emitter.subscribe("event:disable-views", data => {
			if (!data.views) return false;
			// console.log(this.model.activeTickets[0]);
			// this.firstStadiumPlan.filter(this.model.activeTickets[0].id, "view_id");
			this.secondStadiumPlan.filter(data.views, "view_id");
		});

		/* очищает заказ */
		emitter.subscribe("event:cancel-order", data => {
			this.clearOrder();
		});

		emitter.subscribe("event:switch-plan", data => {
			const $tab = $(`[data-event-id=${this.model.activeEventId}]`);
			$tab.tab("show");
		  
			window.dispatchEvent(new CustomEvent("split-tab:shown", {
			  detail: {
				eventId: this.model.activeEventId,
				targetSelector:
				  $tab.attr("data-bs-target") ||
				  $tab.attr("data-target") ||
				  $tab.attr("href")
			  }
			}));
		  
		});
	}

	hasTicketsInEachPlan(items = []) {
		const needIds = [this.model.firstEventId, this.model.secondEventId];
		const presentIds = new Set(items.filter(Boolean).map(i => i.event_id));
		return needIds.every(id => presentIds.has(id));
	}

	updateOrderButton(items = []) {
		if (this.hasTicketsInEachPlan(items)) {
			this.orderInfo.renderOrderButton("enable");
			this.orderInfo.showBuyButton();
		} else {
			this.orderInfo.renderOrderButton("disable");
		}
	}

	_handleSplitResponseBase(res, { stadium = null, place = null, mode = null } = {}) {
		if (!res) {
			return { stop: true, res };
		}
	
		if (res.need_auth) {
			window.location.replace(lkService.getLoginUrl());
			return { stop: true, res };
		}
	
		if (res.redraw) {
			alert("Данное место больше недоступно. Выберите другое.");
	
			if (mode === "add" && stadium && place) {
				stadium.renderSectorPlan({ place }, "redraw");
			}
	
			return { stop: true, res };
		}
	
		return { stop: false, res };
	}

	_syncSplitUi(items = [], mode = "add") {
		if (this.hasTicketsInEachPlan(items)) {
			this.orderInfo.renderContinueButton("disable");
		} else {
			this.orderInfo.renderContinueButton("enable");
		}
	
		const orderData = {
			carts: this.model.activeTickets,
			order: {
				count_tickets: this.model.activeTickets.length,
				amount: this.model.getTotalSum(),
			},
			count: this.model.activeTickets.length || 0,
			summ: this.model.getTotalSum(),
		};
	
		this.orderInfo.renderBottomOrderInfo(orderData, mode);
		this.updateOrderButton(items || []);
		this.checkIsDisableSecondTab();
	}

	_handleSplitAddResponse(res, { place, stadium }) {
		if (res?.limit) {
			alert(
				"Вы превысили максимально допустимое количество мест для брони. " +
				"Если вы хотите купить больше билетов, обратитесь на ticket@cskabasket.ru или купите с 2-х аккаунтов."
			);
			throw new Error("LIMIT");
		}
	
		const base = this._handleSplitResponseBase(res, { stadium, place, mode: "add" });
		if (base.stop) {
			return base.res;
		}
	
		if (res.carts) {
			this.orderInfo.updateOrder(res.carts, this.model.activeEventId);
		}
	
		this.model.activeTickets = this.model.filterActiveTicketsByEvent(res.carts || []);
	
		if (stadium && place) {
			stadium.renderSectorPlan({ place }, "add");
		}
	
		this._syncSplitUi(res.carts || [], "add");
	
		return res;
	}
	  
	_handleSplitRemoveResponse(res, { prevItems = [] } = {}) {
		if (res?.error) {
			window.location.reload();
			return res;
		}
	
		const base = this._handleSplitResponseBase(res, { mode: "remove" });
		if (base.stop) {
			return base.res;
		}
	
		const removedItems = Array.isArray(res.carts) ? res.carts.filter(Boolean) : [];
		const removedIds = new Set(removedItems.map(t => String(t.id)));
		const nextItems = prevItems.filter(t => !removedIds.has(String(t.id)));
	
		this.model.activeTickets = nextItems;
	
		if (removedItems.length) {
			const payload = { carts: removedItems.map(t => ({ sid: t.id })) };
			this.firstStadium.renderSectorPlan(payload, "remove");
			this.secondStadium.renderSectorPlan(payload, "remove");
		}
	
		this._syncSplitUi(this.model.activeTickets, "remove");
	
		return res;
	}

	addPlaceToCart(sid, eventId, viewId = "main", ctx = {}) {
		return this.model
		  .splitAdd(eventId, sid, viewId)
		  .then(res =>
			this._handleSplitAddResponse(res, {
			  place: ctx.place || null,
			  stadium: ctx.stadium || null,
			})
		  )
		  .catch(err => {
			console.log(err);
			if (err?.message === "Не удалось получить url личного кабинета!") {
			  alert("Необходима авторизация!");
			  return;
			}
			throw err;
		  });
	}
	
	removePlaceFromCart(sid, eventId, viewId = "main") {
		const prevItems = (this.model.activeTickets || []).slice();
	
		return this.model
		  .splitRemove(eventId, sid, viewId)
		  .then(res => this._handleSplitRemoveResponse(res, { prevItems }))
		  .catch(err => {
			console.log(err);
			throw err;
		  });
	  }

	  	  /**
	   * Публичный API как у EventController
	   */
	addLodgesToCartStandard(eventId, sid, viewId = "main", ctx = {}) {
	return this.model
		.addLodgeToCartStandardSplit(eventId, sid)
		.then(res =>
		this._handleSplitAddResponse(res, {
			place: ctx.place || null,
			stadium: ctx.stadium || null,
		})
		)
		.catch(err => {
			console.log(err);
			if (err?.message === "Не удалось получить url личного кабинета!") {
				alert("Необходима авторизация!");
				return;
			}
			throw err;
		});
	}
	
	removeLodgesToCartStandard(eventId, sid, viewId = "main") {
		const prevItems = (this.model.activeTickets || []).slice();
	
		return this.model
		  .removeLodgeFromCartStandardSplit(eventId, sid)
		  .then(res => this._handleSplitRemoveResponse(res, { prevItems }))
		  .catch(err => {
			console.log(err);
			throw err;
		  });
	}
	
	clearCart() {
		return this.clearOrder();
	}
	showChildTicketInfo() {
		let popupContent = "";
		if ($("html").attr("lang") === "ru") {
			popupContent = `
					<h3>Обратите внимание!</h3>
					<p class="mb-2 mt-3">С <a href="/page/page?id=2">правилами</a> приобретения ${
						window.IS_SEASON ? "абонементов" : "билетов"
					} и посещения матчей ознакомлен(а)</p>
					<p style="font-size: 16px;">Доступен ${
						window.IS_SEASON ? "абонемент" : "билет"
					} для детей от 7 до 14 лет, приобрести его можно только в паре с обычным. </p>
          <br>
          <button class="btn" data-dismiss="modal">Продолжить</button>
				`;
		} else {
			popupContent = `
					<h3>Note!</h3>
					<p class="mb-2 mt-3">I am familiar with the <a href="/page/page?id=2">rules</a> for purchasing tickets and attending games</p>
					<p style="font-size: 16px;">Tickets are available for children from 7 to 14 years old, but can only be purchased together with a regular ticket.</p>
          <br>
          <button class="btn" data-dismiss="modal">Continue</button>
				`;
		}
		helpers.alert.show(popupContent);
	}

	showRulesPopup() {
		let popupContent = "";
		if ($("html").attr("lang") === "ru") {
			popupContent = `
					<h3>С <a href="/page/page?id=2">правилами</a> приобретения  ${
						window.IS_SEASON ? "абонементов" : "билетов"
					} и посещения матчей ознакомлен(а)</h3>
          <br>
          <button class="btn" data-dismiss="modal">Продолжить</button>
				`;
		} else {
			popupContent = `
					<h3>I have read <a href="/page/page?id=2">the rules</a> for purchasing tickets and attending matches</h3>
          <br>
          <button class="btn" data-dismiss="modal">Continue</button>
				`;
		}

		helpers.alert.show(popupContent);
	}
}

translator.getLanguages().then(() => {
	const split = new SplitController(new SplitView(), new SplitModel());
	split.initSplitStep();
	window.eventController = split;
});
